<mat-card>
    <mat-card-title class="font-weight-bold caption-color">Competition Detail</mat-card-title>
    <mat-divider></mat-divider>
    <mat-card-content class="pt-2">
        <table class="table ">
            <thead>
                <tr>
                    <th>SrNo.</th>
                    <th>Competitor Name</th>
                    <th>Competitor Model</th>
                    <th *ngIf="!IsRental" >Competitor Price</th>
                    <th *ngIf="IsRental" >Tenure</th>
                    <th *ngIf="IsRental" >Rent</th>
                    <th class="text-center" *ngIf="IsCopetitionCsaRateRequired || IsRental">CSA Rate</th>
                    <th class="text-center">Action</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let item of SPRACompetitionDetailArray; let i = index;">
                    <tr>
                        <td>
                            {{i+1}}
                        </td>
                        <td>
                            <input type="text" (ngModelChange)="ComptModelChange(item,i)" name="txtCompName"
                                [(ngModel)]="item.CompName" class="form-control">
                        </td>
                        <td>
                            <input type="text" name="txtCompModel" [(ngModel)]="item.CompModel" class="form-control">
                        </td>
                        <td *ngIf="!IsRental">
                            <input type="number" name="txtCompPrice" [(ngModel)]="item.CompPrice" class="form-control">
                        </td>
                      
                        <td *ngIf="IsRental" >
                            <input type="text" name="txtTenure" [(ngModel)]="item.Tenure" class="form-control">
                        </td>
                        <td *ngIf="IsRental" >
                            <input type="text" name="txtRent" [(ngModel)]="item.Rent" class="form-control">
                        </td>

                        <td (click)="EnterCsaRate(item)" class="text-center" *ngIf="IsCopetitionCsaRateRequired || IsRental">
                            <i class="fa fa-rupee fa-2x" aria-hidden="true"></i>
                        </td>
    
                        <td *ngIf="item.IsNewRow" (click)="deleteRow(i)" class="text-center">
                            <i class="fa fa-trash fa-2x"></i>
                        </td>
                        <td *ngIf="!item.IsNewRow" (click)="addRow(item)" class="text-center">
                            <i class="fa fa-plus fa-2x"></i>
                        </td>
                       
    
                    </tr>
                    <tr  *ngIf="this.Mode!='I'">
                        <td colspan="7" class="text-center"> 
                            <table class="table ">
                                <thead>
                                    <tr>
                                        <th *ngFor="let CSAitem of item?.CsaRate | getCompCsaRateGreaterThenZero"> {{CSAitem.CounterDesc}}</th> 
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td  *ngFor="let CSAitem of item?.CsaRate | getCompCsaRateGreaterThenZero">
                                            {{CSAitem.Rate}} 
                                        </td>
                                        
                                    </tr>
                                </tbody>
                            </table>
    
                        </td> 
                    </tr>
                    </ng-container>
                
            </tbody>
        </table>


    </mat-card-content>
</mat-card>